// test1153
(1153 && 0);
